import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import MaterialIcon from "@/shared/components/utils/MaterialIcon.vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: ["icon", "title", "link"],
  setup(__props) {

const props = __props;


const haveLink = computed(() => {
  return props.link != null;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createVNode(_component_router_link, {
      class: _normalizeClass(["dropdown-item", { disabled: !_unref(haveLink) }]),
      to: { name: __props.link }
    }, {
      default: _withCtx(() => [
        (__props.icon)
          ? (_openBlock(), _createBlock(MaterialIcon, {
              key: 0,
              name: __props.icon,
              class: "me-1"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(__props.title), 1)
      ]),
      _: 1
    }, 8, ["class", "to"])
  ]))
}
}

})